module.exports = __webpack_public_path__ + "static/media/Franklin St San Francisco, CA1.145a10bb.jpg";